module.exports = __webpack_public_path__ + "media/puregym-activity.bf5883a9.mp4";